<template>
    <div class="map-post__slider" :class="{ 'single': images.length == 1 }">
        <div class="slides">
            <VueSlickCarousel ref="carousel" v-bind="settings" @beforeChange="checkDotDistance">

                <template #prevArrow="arrowOption">
                    <button class="prev">
                        <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                        <span class="accessible">Previous</span>
                    </button>
                </template>

                <a :href="`/${spot.city.slug}/${spot.slug}`" v-for="(image, index) in images">
                    <img v-if="index > 9" src="image" loading="lazy">
                    <img v-else :src="image" loading="lazy">
                </a>

                <template #nextArrow="arrowOption">
                    <button class="next">
                        <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                        <span class="accessible">Next</span>
                    </button>
                </template>

                <template #customPaging="page">
                    <div class="custom-dot" :style="{'transform': `translateX(${dotDistance}px)` }"></div>
                </template>

            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {

    props: ['spot'],

    components: {
        VueSlickCarousel
    },

    data() {
        return {
            images: this.spot.images,
            dotDistance: 0,
            settings: {
                slidesToShow: 1,
                dots: true,
                lazyLoad: "ondemand",
            },
        }
    },

    methods: {
        checkDotDistance(oldSlideIndex, newSlideIndex) {
            if (newSlideIndex > 1) {
                if (newSlideIndex == this.images.length - 1) {
                    this.dotDistance = (newSlideIndex - 2) * -10;
                } else {
                    this.dotDistance = (newSlideIndex - 1) * -10;
                }
            } else {
                this.dotDistance = 0;
            }
        },
    }
}
</script>
